import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { CommonModule } from '@angular/common';
import { MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { MerchantActivationModel } from '../models/merchant-activation.model';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: true,
    imports: [ButtonModule, RippleModule, CommonModule],
    providers: [MessageService]
})
export class ConfirmationModalComponent {
    public loading = false;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private merchantService: MerchantService,
        private messageService: MessageService,
        private router: Router
    ) {}

    onConfirm() {
        this.ref.close(true);
        const merchantId = this.config.data?.merchantId;
        const otherEmail = this.config.data?.otherEmail;

        const dto: MerchantActivationModel = {
            MerchantId: merchantId,
            DateActivatedAt: new Date(),
            OtherEmail: otherEmail
        };

        this.merchantService.approvedMerchantStoreStatus(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    return;
                }
                this.router.navigate(['home-root'], { skipLocationChange: true });
            })
            .catch(err => {
                throw err;
            });
    }
}
